export const passwordRequirements = [
  { label: 'Au moins 8 caractères', test: (p: string) => p.length >= 8 },
  { label: 'Une lettre majuscule', test: (p: string) => /[A-Z]/.test(p) },
  { label: 'Un chiffre', test: (p: string) => /\d/.test(p) },
];

export function strengthColor(strength: number, index: number) {
  if (index >= strength) return 'bg-slate-200';
  if (strength === 1) return 'bg-red-500';
  if (strength === 2) return 'bg-orange-500';
  return 'bg-emerald-500';
}
